import { getState, modifyState } from '~src/state';

export const updateMagicEraserBrush = () => {
  const brushRadius = getState('magicEraserBrushRadius');
  const mouseCursor = getState('mouseCursorMagicEraser');
  mouseCursor.set('radius', brushRadius);
  modifyState('mouseCursorMagicEraser', mouseCursor);
  window.magicEraserDrawingCanvas.freeDrawingBrush.width = brushRadius * 2;
  window.cursorCanvas.renderAll();
};
